import { render } from "./SidenavFolderItem.vue?vue&type=template&id=0e75ab1d&scoped=true"
import script from "./SidenavFolderItem.vue?vue&type=script&lang=js"
export * from "./SidenavFolderItem.vue?vue&type=script&lang=js"

import "./SidenavFolderItem.vue?vue&type=style&index=0&id=0e75ab1d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e75ab1d"]])

export default __exports__